import { useIntl } from "react-intl";
import Bug from "src/design-system/icons/Bug.svg?react";
import { DebugSelectors } from "src/domain/DebugWindow/DebugSelectors";
import color from "src/design-system/tokens/color";
import { useState } from "react";
import { useGetPermaLink } from "../../../utils/hooks/useGetPermaLink";
import { NavDropdown } from "../NavDropdown";
import { messages } from "./DebugDropdown.messages";

export function DebugDropdown() {
  const intl = useIntl();
  const permalink = useGetPermaLink();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <NavDropdown
      text={
        <Bug
          title={intl.formatMessage(messages.debugTitle)}
          color={isOpen ? color.icon.brand : color.icon.primary}
        />
      }
      label={intl.formatMessage(messages.debugTitle)}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    >
      <a href={permalink.href} className="inline-block p-4 text-sm underline">
        Current Feature Permalink
      </a>
      <DebugSelectors />
    </NavDropdown>
  );
}
